import { Box } from '@mui/material';
import React from 'react';

import logo from '@/assets/img/logo.png';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';

import { LogoStyles } from './logo.styles.ts';

export const Logo: React.FC = () => {
  const { push } = useAppNavigation();

  const handleClick = () => {
    push(RouteEnum.ROOT);
  };

  return (
    <Box onClick={handleClick} sx={LogoStyles}>
      <img alt="smallLogo" src={logo} style={{ height: '100%' }} />
    </Box>
  );
};
